var map = {
	"./countries/Австралия.png": 4208,
	"./countries/Бразилия.png": 6025,
	"./countries/Великобритания.png": 3404,
	"./countries/Германия.png": 5771,
	"./countries/Египет.png": 9147,
	"./countries/Индия.png": 5889,
	"./countries/Испания.png": 3635,
	"./countries/Италия.png": 371,
	"./countries/Канада.png": 5312,
	"./countries/Китай.png": 3096,
	"./countries/Корея.png": 5325,
	"./countries/Мексика.png": 1017,
	"./countries/ОАЭ.png": 1938,
	"./countries/Португалия.png": 554,
	"./countries/Россия.png": 4382,
	"./countries/СССР.png": 1488,
	"./countries/США.png": 7456,
	"./countries/Турция.png": 6209,
	"./countries/Финляндия.png": 610,
	"./countries/Франция.png": 4551,
	"./countries/Швейцария.png": 9916,
	"./countries/Швеция.png": 6881,
	"./countries/Япония.png": 1611,
	"./genres/аниме.png": 1455,
	"./genres/биография.png": 9432,
	"./genres/боевик.png": 2847,
	"./genres/вестерн.png": 2663,
	"./genres/военный.png": 4618,
	"./genres/детектив.png": 7241,
	"./genres/детский.png": 9344,
	"./genres/для взрослых.png": 9988,
	"./genres/документальный.png": 2036,
	"./genres/драма.png": 4085,
	"./genres/игра.png": 5938,
	"./genres/история.png": 8313,
	"./genres/комедия.png": 7593,
	"./genres/концерт.png": 4329,
	"./genres/короткометражка.png": 7082,
	"./genres/криминал.png": 4005,
	"./genres/мелодрама.png": 1499,
	"./genres/музыка.png": 1186,
	"./genres/мультфильм.png": 8642,
	"./genres/мюзикл.png": 3223,
	"./genres/новости.png": 7861,
	"./genres/приключения.png": 2903,
	"./genres/реальное ТВ.png": 4565,
	"./genres/семейный.png": 5428,
	"./genres/спорт.png": 4465,
	"./genres/ток-шоу.png": 9797,
	"./genres/триллер.png": 4046,
	"./genres/ужасы.png": 6760,
	"./genres/фантастика.png": 373,
	"./genres/фильм-нуар.png": 6477,
	"./genres/фэнтези.png": 5805,
	"./genres/церемония.png": 3879,
	"./logo/logo.png": 4111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2014;